import { DeliverySpotDoc } from '@gooduncles/gu-app-schema';
import { GridApi, IRowNode, NewValueParams } from 'ag-grid-enterprise';
import { message, notification } from 'antd';

import { DeliverySpotWithShopRowData } from 'src/components/Delivery/DeliverySpotWithStore/DeliverySpotWithShopTable';

import { errorObjectToString } from './common';
import { batchEnd, batchStart, updateDeliverySpot } from './firebase/firebase-short-cut';

/**
 * 배송지 관리의 드래그 종료 후 호출된다.
 */
export const onDeliverySpotRowDragEnd = async (params: any) => {
  const gridApi = params?.api as GridApi;
  if (!gridApi) {
    notification.error({
      message: 'grid api를 찾을 수 없습니다.',
    });
    return;
  }

  const chagnedNodes: IRowNode<DeliverySpotDoc>[] = [];
  gridApi.forEachNode((node) => {
    const { rowIndex, data } = node;
    // 1. 순서가 변경된 노드 즉 rowIndex + 1과 data.index가 다른 노드만 추출한다.
    if (rowIndex !== null && rowIndex + 1 !== data.sortKey) {
      chagnedNodes.push(node);
    }
  });

  if (!chagnedNodes || chagnedNodes?.length === 0) {
    return;
  }

  try {
    const updateList = chagnedNodes.map((node) => {
      const { rowIndex, data } = node;
      return { _id: data?._id, sortKey: (rowIndex ?? 999) + 1 };
    });
    batchStart();
    for (const item of updateList) {
      if (!item._id) {
        continue;
      }
      await updateDeliverySpot(item._id, { sortKey: item.sortKey, sortKeyForBadge: item.sortKey }, { bBatch: true });
    }
    await batchEnd();
    message.success('순서를 변경했습니다.');
  } catch (error) {
    console.error(error);
    const description = errorObjectToString(error);
    notification.error({
      message: '순서 변경에 실패했습니다.',
      description,
    });
  }
};

export const onDeliverySpotSortKeyChange = async (params: NewValueParams<DeliverySpotWithShopRowData>) => {
  const id = params.data?._id;
  if (!id) {
    notification.error({
      message: 'id를 찾을 수 없습니다.',
    });
    return;
  }
  try {
    await updateDeliverySpot(id, { sortKey: params.newValue, sortKeyForBadge: params.newValue });
    message.success('순서를 변경했습니다.');
  } catch (error) {
    console.error(error);
    const description = errorObjectToString(error);
    notification.error({
      message: '순서 변경에 실패했습니다.',
      description,
    });
  }
};
